import React from 'react';
import { BaseIcon } from '../base/BaseIcon';
import { IconProps } from '../types';

export const ArrowAngleIcon = React.memo<IconProps>(
  ({
    className = '',
    size = 24,
    color = 'currentColor',
    onClick,
    strokeWidth,
  }) => (
    <BaseIcon
      className={className}
      size={size}
      color={color}
      onClick={onClick}
      viewBox="0 0 24 24"
      strokeWidth={strokeWidth}
    >
      <path
        d="M21.5001 1.5H6.72006C6.17006 1.5 5.72006 1.95 5.72006 2.5C5.72006 3.05 6.17006 3.5 6.72006 3.5H19.0801L1.79006 20.79C1.40006 21.18 1.40006 21.81 1.79006 22.2C2.18006 22.59 2.81006 22.59 3.20006 22.2L20.5001 4.91V17.27C20.5001 17.82 20.9501 18.27 21.5001 18.27C22.0501 18.27 22.5001 17.82 22.5001 17.27V2.5C22.5001 1.95 22.0501 1.5 21.5001 1.5Z"
        fill={color}
      />
    </BaseIcon>
  ),
);

ArrowAngleIcon.displayName = 'ArrowAngleIcon';
